export const appendExtraParamsWithPossibleKeyDupes = (originalParams, extraParams) => {
  return extraParams.reduce((paramObject, keyValuePair) => {
    const pairKey = Object.keys(keyValuePair)[0];
    const pairValue = keyValuePair[pairKey];
    if (Object.keys(paramObject).includes(pairKey)) {
      return {
        ...paramObject,
        [pairKey]: [].concat(paramObject[pairKey], pairValue),
      };
    }
    return {
      ...paramObject,
      ...keyValuePair,
    };
  }, originalParams);
};
